module.exports = __webpack_public_path__ + "static/img/active_vip_06.f679a22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/images/activity/active_vip_06.jpg
// module id = 5nw1
// module chunks = 0